import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight, ShieldCheck } from "lucide-react";

const NAV = [
  { label: "Home", href: "/" },
  { label: "Investments", href: "/investments" },
  { label: "How it works", href: "/#how-it-works" },
  { label: "About", href: "/about" },
  { label: "FAQ", href: "/#faq" },
  { label: "Contact", href: "/#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md border-b border-[#0d1a2e]/8" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <div className="w-10 h-10 rounded-xl bg-[#0d1a2e] flex items-center justify-center shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]">
            <ShieldCheck className="w-5 h-5 text-[#16d196]" strokeWidth={2.4} />
          </div>
          <div className="leading-tight">
            <div className="text-[19px] font-extrabold tracking-tight text-[#0d1a2e]">
              Investment<span className="text-[#16d196]">Hub</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#0d1a2e]/55 -mt-0.5 font-medium">
              UK · No Cold Calls
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => {
            const active = n.href === pathname;
            return (
              <Link
                key={n.href}
                to={n.href}
                className={`px-3.5 py-2 text-[14.5px] font-semibold rounded-md transition-colors ${
                  active
                    ? "text-[#16d196]"
                    : "text-[#0d1a2e]/75 hover:text-[#0d1a2e]"
                }`}
              >
                {n.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <Link to="/apply">
            <button className="inline-flex items-center gap-1.5 bg-[#16d196] hover:bg-[#13b884] text-[#0d1a2e] rounded-full h-11 px-5 text-[14.5px] font-bold transition-colors shadow-[0_4px_14px_rgba(22,209,150,0.35)]">
              Get matched
              <ArrowRight className="w-4 h-4" strokeWidth={2.6} />
            </button>
          </Link>
        </div>

        <button
          className="lg:hidden text-[#0d1a2e] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#0d1a2e]/8 bg-white">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.href}
                to={n.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-[15px] font-semibold text-[#0d1a2e]/85"
              >
                {n.label}
              </Link>
            ))}
            <Link to="/apply" onClick={() => setOpen(false)} className="mt-2">
              <button className="w-full inline-flex items-center justify-center gap-1.5 bg-[#16d196] hover:bg-[#13b884] text-[#0d1a2e] rounded-full h-12 text-[15px] font-bold">
                Get matched <ArrowRight className="w-4 h-4" strokeWidth={2.6} />
              </button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
